"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkerPopup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MarkerPopupItem_1 = __importDefault(require("./MarkerPopupItem"));
const react_ui_1 = require("@pasport/react-ui");
const constants_1 = require("../../constants");
const Popup_1 = __importDefault(require("./Popup"));
function MarkerPopup({ subtitle, title, items, detailUrl, marker, children }) {
    const onClose = () => {
        window.dispatchEvent(new Event(constants_1.CLOSE_ALL_POPUPS_EVENT));
    };
    return ((0, jsx_runtime_1.jsxs)(Popup_1.default, { onClose: onClose, children: [(0, jsx_runtime_1.jsxs)("div", { style: { flex: 1 }, children: [subtitle && ((0, jsx_runtime_1.jsx)("span", { className: "card-subtitle text-muted", children: subtitle })), (0, jsx_runtime_1.jsx)("h6", { className: "card-title", children: (0, jsx_runtime_1.jsx)("strong", { children: title }) })] }), (0, jsx_runtime_1.jsxs)("div", { style: { marginTop: -5 }, children: [items?.map((item, index) => {
                        return ((0, jsx_runtime_1.jsx)(MarkerPopupItem_1.default, { label: item.label, value: item.value }, item.label));
                    }), children] }), (0, jsx_runtime_1.jsxs)("div", { style: { display: "flex", flexDirection: "row" }, className: "mt-2", children: [(0, jsx_runtime_1.jsx)(react_ui_1.Button, { onPress: () => {
                            marker.map?.flyTo(marker.location, marker.map.getMaxZoom());
                        }, size: "small", children: "P\u0159ibl\u00ED\u017Eit" }), (0, jsx_runtime_1.jsx)("div", { style: { flex: 1 } }), detailUrl && ((0, jsx_runtime_1.jsx)("a", { href: detailUrl, target: "_blank", children: (0, jsx_runtime_1.jsx)(react_ui_1.Button, { variant: "outlined", size: "small", icon: (0, jsx_runtime_1.jsx)("i", { className: "bi bi-link-45deg" }), children: "Otev\u0159\u00EDt detail" }) }))] })] }));
}
exports.MarkerPopup = MarkerPopup;
{
    /* <div style={{display:"flex", flexDirection: "row"}}>
            <div style={{flex:1}}>
            <span className='card-subtitle text-muted'>Vodorovné dopravní značení</span>

                <h6 className="card-title h6" ><strong>Označení objektu: {sign.oznaceni}</strong></h6>
            </div>
            <button type="button" className="close" aria-label="Close" onClick={onClose} >
                <span aria-hidden="true" style={{position: "absolute", top: 5, right: 10}}>&times;</span>
            </button>
        </div>

        <div  style={{flex:1}}>
            <span className='card-subtitle text-muted'>Značení s kódem</span>
            <h6 className="card-title h6"><strong>{sign.znaceniSlovne} {`(${sign.kodZnaceni})`}</strong></h6>
        </div>


        <div style={{display: "flex", flexDirection: "row"}}>
            <button onClick={()=>{
                marker.map?.flyTo(marker.location, marker.map.getMaxZoom())
            }} role="button" className="btn btn-primary btn-sm">Přiblížit</button>
            <div style={{flex: 1}}/>
            <a href={detailUrl} target='_blank' >
                <button role="button" className="btn btn-outline-primary btn-sm">
                    <i className="bi bi-link-45deg"></i> Otevřít detail</button>
            </a>

        </div> */
}
